import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, map } from 'rxjs';
import { UserService } from './account/user.service';

@Injectable({
  providedIn: 'root',
})
export class FormValidatorsService {
  constructor(private userService: UserService) {}

  emailValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> =>
      this.userService.checkIfEmailExists(control.value).pipe(map(res => (res ? { emailExists: true } : null)));
  }
}
